module.exports = __webpack_public_path__ + "static/media/blueBell.e909291b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blueBell.svg
// module id = 447
// module chunks = 0